export const shorouk = {
  title: "ونش انقاذ الشروق | أسرع ونش في مدينة الشروق بخصم 50%",
  metaDescription: "أسرع ونش انقاذ في الشروق وطريق السويس. نصل إليك فوراً داخل أحياء الشروق 1 و2 و3 لإنقاذ السيارات المعطلة بأسعار ممتازة. اتصل الآن 01055557235",
  intro: "تحتاج إلى ونش انقاذ الشروق؟ نحن نقدم أسرع خدمة استجابة في مدينة الشروق والمناطق المحيطة بها. بفضل تمركزنا على مداخل الشروق وطريق السويس، نضمن لك وصول الونش في وقت قياسي.",
  landmarks: ["مدخل الشروق 1", "مدخل الشروق 2", "أكاديمية الشروق", "نادي هليوبوليس الشروق", "طريق السويس"],
  seoText: `
    <h3>خدمة ونش انقاذ الشروق الفورية</h3>
    <p>
      مدينة الشروق من المدن الجديدة الهادئة، ولكن في حالة تعطل سيارتك، تحتاج إلى خدمة <strong>ونش انقاذ الشروق</strong> موثوقة وسريعة للتعامل مع الموقف. 
      فريقنا متواجد باستمرار لتغطية كافة أحياء المدينة، من الشروق 1 وحتى الشروق 3، بالإضافة إلى التمركز الدائم على طريق السويس.
    </p>
    <p>
      نوفر أوناش سطحة مجهزة لنقل سيارتك بأمان تام، سواء كنت تحتاج لنقلها إلى مركز صيانة داخل الشروق، أو إلى القاهرة الجديدة.
    </p>
  `,
  faqs: [
    {
      q: "ما هو وقت الاستجابة في مدينة الشروق؟",
      a: "نصل إليك عادة في غضون 15 إلى 20 دقيقة كحد أقصى بفضل تمركزنا الدائم في المنطقة."
    },
    {
      q: "هل تنقلون السيارات خارج مدينة الشروق؟",
      a: "نعم، نقدم خدمة النقل من الشروق إلى أي مكان آخر في القاهرة أو المحافظات."
    }
  ]
};
